export default {
  data() {
    return {
      ValidationErrorMessage: null,
      Donation: null,
      DonationName: null,
      DonationAmount: 50,
      DonationAppFeeAmount: 2,
      DonationGatewayActive: false,
      DonationCompleted: false,
      DonationAnonymousName: false,
      DonationAnonymousAmount: false,
      DonationShowCommentForm: false,
      DonationComment: null,
      DonationFundraiserChild: null,
      StripeCheckoutObject: null
    }
  },
  watch: {
    DonationAmount(newVal) {
      this.DonationAppFeeAmount = Math.ceil(newVal * 0.08);
      if (this.DonationAppFeeAmount < 2) {
        this.DonationAppFeeAmount = 2;
      } else if (this.DonationAppFeeAmount > 6.99) {
        this.DonationAppFeeAmount = 6.99;
      }
    }
  },
  computed: {
    donationTotalAmount() {
      if(!this.DonationAmount) return 0
      return parseInt(this.DonationAmount) + this.DonationAppFeeAmount
    },
    donateButtonDisabled() {
      return this.DonationGatewayActive || this.DonationCompleted || !this.DonationAmount || !this.DonationName
    }
  }
}
